export default __webpack_public_path__ + "static/media/acct-client-lunch.da43f9b2.png";